var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEggTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "75mm",
    height: "75mm",
    viewBox: "0 0 212.6 212.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.21,191.16c-22,0-38.87-6.79-50.11-20.17-9.6-11.42-14.67-27.51-14.67-46.52,0-22.54,7.27-48.16,19.45-68.52,13-21.72,29.52-34.18,45.33-34.18,35.24,0,65.43,56,65.43,101.86,0,19.2-5.13,35.48-14.85,47.07C145.41,184.28,128.39,191.16,106.21,191.16Zm0-162.59c-13.36,0-27.76,11.25-39.5,30.87-11.57,19.35-18.48,43.66-18.48,65,0,17.39,4.52,32,13.08,42.15,9.89,11.77,25,17.74,44.9,17.74,20.08,0,35.34-6.07,45.37-18,8.67-10.35,13.26-25.12,13.26-42.7C164.84,77.43,134.7,28.57,106.21,28.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.42,48.77a111.77,111.77,0,0,1-5.28,10.62l-5.48,9.84C84.84,72.5,83,75.77,81,79.06a75.67,75.67,0,0,1-6.77,9.82,39.09,39.09,0,0,1,1.44-12.06,49.14,49.14,0,0,1,4.57-11.18,45.72,45.72,0,0,1,7.28-9.72A34.78,34.78,0,0,1,97.42,48.77Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggTag);
export default __webpack_public_path__ + "static/media/EggTag.271e91c5ee8ec9e936eda9c5ef738715.svg";
export { ForwardRef as ReactComponent };